import { render, staticRenderFns } from "./perfil-profesor.vue?vue&type=template&id=7a0f6a07&"
import script from "./perfil-profesor.vue?vue&type=script&lang=js&"
export * from "./perfil-profesor.vue?vue&type=script&lang=js&"
import style0 from "./perfil-profesor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports